import OperationalTarget from './OperationalTarget';

import "./OperationalTarget.scss";

export * from './OperationalTarget.types';

export { OperationalTarget };

